const cancel = 'Annuleren'
const save = 'Opslaan'

export default {

  global: {
    generalError: 'Oeps! Het verzoek kon niet verwerkt worden. Laad de pagina opnieuw.',
    signature: 'Met vriendelijke groeten,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
    },

    addButton: {
      add: 'Add',
    },

    attachments: {
      add: 'Een cv of andere bijlagen toevoegen',
      placeholderWithDescription: 'Voeg de gevraagde bijlagen toe',
      remove: 'Verwijderen',
      allowedFileTypes: 'Toegestane bestandstypen',
      errors: {
        size: 'Bestand is te groot, maximumgrootte van het bestand is 5MB.',
        empty: 'Bestand bevat geen gegevens',
        invalidType: fileType => `Sorry, ${fileType}-bestanden zijn vanwege veiligheidsredenen niet toegestaan`,
        typeNotWhitelisted: 'Sorry, bestandstype is niet toegestaan.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Privacybeleid',
      termsLinkText: 'Algemene voorwaarden',
      privacyPolicyText: 'Wij vinden uw privacy belangrijk. Lees ons ',
      termsText1: 'Lees en aanvaard de ',
      termsText2: 'voordat u ons uw persoonlijke gegevens verstrekt.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Als je niet wilt dat we je persoonlijke gegevens verwerken, vraag dan om verwijdering door ons een bericht te sturen via ${mail}.`,
      customSupportPrivacyInfo: link => `Als u niet wilt dat wij uw persoonlijke gegevens verwerken, kunt u om verwijdering vragen door contact met ons op te nemen via ${link}.`,
    },

    buttons: {
      close: 'Afsluiten',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Opname verwijderen',
      confirm: 'Probeer nogmaals',
    },

    confirmButton: {
      wait: count => `Wacht ${count}`,
      confirm: 'Bevestigen',
    },

    controlStatus: {
      text: {
        empty: 'Invullen',
        valid: () => 'Gereed',
      },
      textarea: {
        empty: 'Invullen',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Instellen',
        valid: () => 'Gereed',
      },
      file: {
        empty: 'Selecteren',
        valid: () => 'Wijzigen',
      },
      list: {
        empty: 'Toevoegen',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Zoeken',
        valid: () => 'Gereed',
      },
    },

    cookieConsentModal: {
      title: 'Onze website maakt gebruik van cookies',
      body: 'Door cookies te accepteren, stemt u ermee in dat er cookies op uw apparaat worden opgeslagen om uw navigatie-ervaring op de website te verbeteren, het websitegebruik te analyseren en onze marketingactiviteiten te ondersteunen.',
      learnMoreLinkText: 'Meer informatie over ons gebruik van cookies',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Cookies beheren',
      acceptAll: 'Alle cookies accepteren',
      manageTitle: 'Toestemmingsvoorkeuren beheren',
      necessaryCookiesTitle: 'Noodzakelijke cookies',
      necessaryCookiesBody:
        'Deze cookies zijn noodzakelijk voor het goed functioneren van de website en kunnen niet worden uitgeschakeld in onze systemen.',
      performanceCookiesTitle: 'Prestatiecookies',
      performanceCookiesBody:
        'Met deze cookies kunnen we het aantal bezoeken en verkeersbronnen meten, zodat we de prestaties van onze website kunnen verbeteren.',
      confirmChoices: 'Bevestig mijn voorkeuren',
      marketingCookiesTitle: 'Marketingcookies',
      marketingCookiesBody:
        'Deze cookies maken het mogelijk om advertenties te personaliseren en de prestaties ervan te meten.',
      functionalCookiesTitle: 'Functionaliteitscookies',
      functionalCookiesBody:
        'Deze cookies worden gebruikt om de functionaliteit van de website te verbeteren. Zonder deze cookies is het mogelijk dat bepaalde functionaliteit niet beschikbaar is. Voorbeelden van functionaliteitscookies zijn webchatdiensten en gebruikersvoorkeuren.',
    },

    emailAddresses: {
      remove: 'Verwijderen',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Niet toegestaan',
      content: 'Onze server heeft beleefd (maar beslist) geweigerd een verzoek van uw browser uit te voeren. Houd er rekening mee dat Recright met slechts één apparaat/browser (tegelijkertijd) gebruikt kan worden.',
      link: 'Beginpagina',
    },

    error404: {
      heading: 'Niets te vinden',
      content: 'We hebben heel hard gezocht, maar er is geen webpagina op het opgevraagde adres. Misschien hebt u op een verlopen link geklikt of per ongeluk het verkeerde adres ingetypt.',
      link: 'Beginpagina',
    },

    error410: {
      heading: 'Gesloten',
      content: 'De vacature kan niet worden getoond omdat deze is gesloten of omdat de sollicitatieperiode is afgelopen.',
      link: 'Beginpagina',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Initialiseren...',
      connection_error_hint: 'Er kan geen netwerkverbinding tot stand worden gebracht.\nProbeer de pagina opnieuw te laden.',
      permission_hint: 'U moet deze site toestemming geven om uw webcam en microfoon te gebruiken.',
      searching_camera_hint: 'Zoeken naar een webcam...',
      camera_reserved_hint: 'Een andere applicatie of webpagina heeft uw webcam gereserveerd.\nSluit die applicatie en laad deze pagina opnieuw.',
      camera_reserved_hint_chrome_extra: '\n\nBeste Chrome-gebruiker, u moet Recright toestemming geven om de webcam te gebruiken in het dialoogvenster onder de adresbalk.',
      no_camera_hint: 'Webcam kan niet worden gevonden.',
      no_mic_hint: 'Microfoon kan niet worden gevonden.',
      uploading_text: 'uploading ...',
      rtmpt_in_use: 'Deze stap is niet nodig als uw netwerk-\nbeheerder RTMP toestaat. Vraag ons hoe dit gaat.',
      preview_text: 'De webcam bevindt zich in de voorbeeldmodus',
      close_text: 'Camera afsluiten',
      remove_text: 'Opname verwijderen',
      noflash_errortext_install: link => `Het lijkt erop dat u geen Adobe Flash Player hebt. U hebt een Flash-plug-in nodig om video's op te nemen. Download Flash hier: ${link}`,
      noflash_errortext_enable: link => `Hebt u Flash al geïnstalleerd, maar ziet nog steeds dit bericht? Kijk dan hier: ${link}`,
      noflash_errortext_differentbrowser: 'U kunt het ook proberen met een browser die HTML5-opnames ondersteunt. We raden Chrome of Firefox aan.',
    },

    footer: {
      terms: 'Gebruiksrechtovereenkomst',
      license: 'General Terms of Service',
      privacyPolicy: 'Privacybeleid',
      customSupport: link => `Contact opnemen via ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Hoe zou u uw interviewervaring beoordelen?',
      howWouldYouRateJobAd: 'Hoe zou u de sollicitatie-ervaring beoordelen?',
      yourResponseIsAnonymous: 'Je reactie is anoniem.',
      thankYouFeedback: 'Dank u wel voor uw feedback!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Sorry, bestandstype is niet toegestaan.',
      isRequired: 'Dit veld is verplicht.',
      isEmail: value => `${value} is geen geldig e-mailadres.`,
      isDate: value => `${value} is geen geldige datum.`,
      invalidUrl: 'Webadres is ongeldig.',
      singleHireEndError: 'Eenmalig inhuren kan niet langer dan 60 dagen worden gebruikt.',
      isNotTooOldForLive: 'Datum ligt in het verleden.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Naam',
      city: 'woonplaats',
      email: 'E-mail',
      phone: 'Telefoonnummer',
      applyForPosition: 'Reageren op vacature',
      back: 'Terug',
      continue: 'Doorgaan',
      submit: 'Verzenden',
      saveForLater: 'Later doorgaan',
      namePlaceholder: 'Vul uw naam in',
      emailPlaceholder: 'Vul uw e-mailadres in',
      phonePlaceholder: 'Vul uw telefoonnummer in',
      cityPlaceholder: 'Voer in in welke stad/welk dorp je momenteel woont',
      links: 'Voeg links toe, bijvoorbeeld uw LinkedIn-profiel',
      legendBasicInfo: 'Basisinformatie',
      legendLinks: 'Links',
      legendAttachments: 'Bijlagen',
      legendAdditionalFields: 'Aanvullende informatie',
      coverLetter: 'Motivatiebrief',
      attachments: 'Bijlagen',
      introduction: 'Schrijf hier een korte introductie',
      thankYou: 'Hartelijk dank.',
      luck: 'Veel succes!',
      close: 'close',
      required: 'Items gemarkeerd met * zijn verplicht.',
    },

    jobAdContainer: {
      endTime: date => (date ? `open until ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Reageren op vacature',
    },

    jobAdQuickInterview: {
      title: 'Snelle videosollicitatie',
      back: 'Terug',
      submit: 'Verzenden',
      saveForLater: 'Later doorgaan',
      description: 'Om u sneller te leren kennen, nodigen we u uit om kort te antwoorden op onze snelle sollicitatievraag. Laat iets zien van uw persoonlijkheid en geef uw sollicitatie diepgang.',
      requiredNote: 'Houd er rekening mee dat dit een onderdeel is van het sollicitatieproces. De recruiter ontvangt uw sollicitatie pas nadat u uw antwoord hebt opgenomen.',
      reminderNote: 'U kunt uw antwoord meteen opnemen, of u kunt een herinnering per e-mail krijgen om later door te gaan.',
    },

    jobAdRow: {
      responses: 'Sollicitaties',
      status: {
        open: 'Openen',
        filled: 'Ingevuld',
        cancelled: 'Geannuleerd',
        done: 'Klaar',
        close: 'Afsluiten',
        draft: 'Gesloten (concept)',
        hidden: 'Verborgen',
      },
    },

    interviewRow: {
      responses: 'Kandidaten',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'LinkedInprofiel weergeven',
    },

    linkedInButton: {
      error: 'Fout tijdens ophalen van het profiel. Probeer het opnieuw.',
      buttonText: 'Solliciteer via linkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Je kunt je LinkedInprofiel gebruiken om het formulier in te vullen',
      linkedInOr: 'Of',
      error: 'Fout tijdens ophalen van het profiel. Probeer het opnieuw.',
    },

    linkListInput: {
      addField: 'Add',
      removeField: 'Remove',
      invalidUrl: 'Webadres is ongeldig.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
    },

    loadingButton: {
      loading: 'Wordt geladen...',
      saving: 'Opslaan...',
      sending: 'Verzenden...',
    },

    modalApplicationForm: {
      applyForPosition: 'Solliciteren',
      continue: 'Doorgaan',
      name: 'Vul uw naam in',
      email: 'Vul uw e-mailadres in',
      phoneNumber: 'Vul uw telefoonnummer in',
      links: 'U kunt links invullen',
      legendLinks: 'Links',
      legendAttachments: 'Bijlagen',
      coverLetter: 'Motivatiebrief',
      attachments: 'Bijlagen',
      introduction: 'Schrijf hier uw introductie',
      thankYou: 'Hartelijk dank.',
      luck: 'Veel succes!',
      close: 'Afsluiten',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Deelbare openbare link',
      info: 'Hier is de openbare link naar een vacature om te delen.\nIedereen met interesse in de functie kan de vacature zien\nen er vervolgens op reageren.\nU ontvangt de gebruikelijke melding wanneer er sollicitaties zijn.\n\nHier is een openbare link naar de vacature:',
    },

    modalVideoAdd: {
      title: 'Een nieuwe video toevoegen',
      chooseTitle: 'Een nieuwe video toevoegen',
      titlePlaceholder: 'Vul hier de videotitel in',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Een nieuwe video uploaden',
      info: 'Maximaal toegestane videoformaat is 500 MB. We raden u aan de video\'s te comprimeren voor het uploaden, zodat het uploaden en de conversie minder tijd kosten.',
    },

    modalCandidateInfo: [
      {
        headline: 'Videoreactie opnemen ',
        content: 'zo vaak als u wilt. De video\'s worden onmiddellijk na de opname opgeslagen en u kunt terugkeren naar het videogesprek via de link die u in per e-mail hebt ontvangen.',
        mobileContent: 'zo vaak als u wilt. Voeg de video aan het interview toe. Je ziet hoe de video wordt geüpload en opgeslagen in het interview. Met de koppeling die je via e-mail ontving kun je terugkeren naar het videogesprek. <br><br><strong>Als u een mobiel apparaat van Apple gebruikt en uw scherm zwart blijft, staan <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">hier</a> instructies om dat probleem te verhelpen.</strong>',
      },
      {
        headline: 'Na de opname, ',
        content: 'zorg ervoor dat de video correct wordt afgespeeld en uw stem hoorbaar is. Als u op de knop "Verzenden" drukt, wordt uw antwoord vergrendeld en kunt u het niet meer bewerken.',
      },
      {
        headline: 'Als u klaar bent met het gesprek, ',
        content: 'druk dan op de knop "Antwoord verzenden en gesprek voltooien". Hierna kunt u niet teruggaan naar het videogesprek. Als u deze pagina wilt sluiten maar later wilt doorgaan met het gesprek, druk dan op de knop "Later doorgaan later".',
      },
      {
        headline: 'Als u hulp nodig hebt ',
        content: mailto => `bij het reageren op het videopgesprek, klik dan tijdens het beantwoorden van het video-gesprek op de "help"-knop rechtsonder op de pagina of stuur ons een bericht per e-mail via ${mailto}.`,
        customContent: link => `Contact opnemen via ${link}`,
      },
    ],

    navigationBar: {
      back: 'Terug',
      dashboard: 'Dashboard',
      frontpage: 'Beginpagina',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Telefoonnummer met indeling ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Gemiddelde score',
      reset: 'resetten',
    },

    share: {
      share: 'Delen op',
      copy: 'Link kopiëren',
    },

    sort: {
      sort: 'Sorteren',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Geselecteerd',
      change: 'Wijzigen',
    },

    video: {
      videoNotFound: 'Video wordt verwerkt of video is niet gevonden',
      retry: 'Probeer nogmaals',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Een nieuwe video uploaden of opnemen' : 'Bestand selecteren'),
      videoPlaceholder: 'Reactie opnemen',
      uploadPlaceholderCandidate: 'Een video uploaden',
      submit: 'Reactie verzenden',
      notAnswered: 'Nog niet beantwoord',
      remove: 'Opname verwijderen',
      converting: 'De video wordt geconverteerd. Een moment geduld...',
      uploading: 'De video wordt geüpload. Een moment geduld...',
      error: {
        invalid: 'Het geselecteerd bestand is te groot. Selecteer een ander bestand.',
        upload: 'We konden de video helaas niet uploaden. Probeer nogmaals.',
        transcode: 'Het geselecteerde videobestand is beschadigd of niet geldig. Probeer nogmaals.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Meer weergeven',
      showLessButtonText: 'Minder weergeven',
      infoText1:
        'Tabblad in de voorgrond actief houden tijdens de opname. U mag geen andere toepassing gebruiken tijdens de opname.',
      infoText2:
        "Video's met achtergrondvideo werken het beste op de nieuwste browsers en met een apparaat dat relatief nieuw en krachtig is.",
      infoText3:
        'Zorg ervoor dat andere toepassingen geen gebruik maken van de microfoon of de camera.',
    },

    videoResponse: {
      videoPlaceholder: 'Reactie opnemen',
      uploadPlaceholder: 'Een video uploaden',
      submit: 'Reactie verzenden',
      notAnswered: 'Nog niet beantwoord',
      startInterview: 'Start interview',
    },

    webcam: {
      useVideoBgButtonText: 'Video-achtergrond gebruiken',
      removeVideoBgButtonText: 'Video-achtergrond verwijderen',
      starting: 'Starten...',
      close: 'Camera afsluiten',
      remove: 'Opname verwijderen',
      record: 'Opnemen',
      stop: 'Stoppen',
      retake: 'Opnieuw',
      submit: 'Reactie verzenden',
      converting: 'De video wordt geconverteerd. Een moment geduld...',
      uploading: 'De video wordt geüpload. Een moment geduld...',
      downloading: 'De video wordt gedownload. Een moment geduld...',
      processing: 'Wordt verwerkt...',
      uploadInProgress: 'Het uploaden van de video is nog bezig, de browser niet sluiten en de pagina niet wijzigen.',
      uploaded: 'Video geüpload.',
      error: {
        DevicesNotFoundError: 'Kan camera of microfoon niet gebruiken. Controleer of ze zijn ingeschakeld.',
        NotFoundError: 'Kan camera of microfoon niet gebruiken. Controleer of ze zijn ingeschakeld.',
        NotAllowedError: 'U hebt geen toestemming gegeven om de camera of microfoon te gebruiken.',
        PermissionDismissedError: 'U hebt het toestemmingsdialoogvenster afgesloten. Geef toestemming om de camera en microfoon te gebruiken.',
        PermissionDeniedError: 'U hebt toegang tot de camera of microfoon geweigerd.',
        NotReadableError: 'Kan de input van de camera of microfoon niet lezen. Mogelijk hardwareprobleem.',
        SecurityError: 'Kan de camera of microfoon niet gebruiken vanwege beveiligingsfout',
        stream: 'Er is een fout opgetreden. Start uw browser opnieuw. Probeer het met een andere browser als het probleem zich blijft voordoen.',
        download: 'Video downloaden mislukt. Nogmaals proberen?',
        upload: 'Video uploaden mislukt. Nogmaals proberen?',
        emptyBlob: 'Het geheugen van uw browser of apparaat is vol, de opname kan niet aangemaakt worden. Vernieuw de pagina. Als dat niet helpt, herstart dan de browser.  Probeer het met een andere browser als het probleem zich blijft voordoen.',
        alternativeRecorder: 'U kunt ook een bestand uploaden door hier te klikken.',
        reconnecting: 'De verbinding is verbroken. Er wordt opnieuw verbinding gemaakt.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Hallo! We willen u uitnodigen voor een videosollicitatie ${title}! Deze uitnodiging is ook naar uw e-mail gestuurd. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
